"use client";

import { CandleSetupGroup, DataItem } from "@/types";
import { CandlePatternInfo } from "@/lib/candlePatternInfo";
import SignalWorkspace from "./SignalWorkspace";

interface ReversalTabProps {
  items: DataItem[];
  uniqueTypes: string[];
  setupGroups?: CandleSetupGroup[];
  selectedType: string | null;
  onSelectType: (type: string | null) => void;
  selectedPatternInfo: CandlePatternInfo | null;
  trendFilter: "all" | "up" | "down";
  setTrendFilter: (filter: "all" | "up" | "down") => void;
}

export default function ReversalTab(props: ReversalTabProps) {
  return (
    <SignalWorkspace
      {...props}
      mode="reversal"
      title="Reversal Setup Scanner"
      description="Use reversal families to isolate possible turning points, then confirm whether the underlying candle and structure context support the idea."
      emptyMessage="Select a reversal family from the explorer to review the live matches and the surrounding setup context."
    />
  );
}
